import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const INDEXING_ENABLED = true;

const SITE = {
  name: "LANDKING Saudi Arabia",
  domain: "https://www.landkingksa.com",
  ogImage: "https://www.landkingksa.com/og-image.jpg",
  twitterCard: "summary_large_image",
  locale: "en_SA"
};

const SEO_MAP = {
  "/": {
    "title": "LANDKING - BTATC | Light Commercial Vehicles in Saudi Arabia",
    "description": "Official LANDKING distributor in Saudi Arabia. Light commercial vehicles for delivery, cargo and fleet operations, with genuine parts and professional aftersales support."
  },
  "/vehicles": {
    "title": "Vehicles | LANDKING Light Commercial Vehicles Saudi Arabia",
    "description": "Explore LANDKING light commercial vehicles in Saudi Arabia. Efficient and reliable LCV models for urban transport, cargo delivery and business fleets."
  },
  "/vehicles/h-series": {
    "title": "H-Series | LANDKING Light Commercial Vehicles Saudi Arabia",
    "description": "Discover the LANDKING H-Series light commercial vehicles in Saudi Arabia, designed for delivery operations and daily business transport needs."
  },
  "/spare-parts": {
    "title": "Spare Parts | Genuine LANDKING LCV Parts Saudi Arabia",
    "description": "Genuine spare parts for LANDKING light commercial vehicles in Saudi Arabia. Ensure performance, reliability and long-term durability."
  },
  "/services": {
    "title": "Services | LANDKING LCV Maintenance Saudi Arabia",
    "description": "Professional maintenance and aftersales services for LANDKING light commercial vehicles across Saudi Arabia, including repairs and warranty support."
  },
  "/about-us": {
    "title": "About LANDKING Saudi Arabia | Official Distributor",
    "description": "BTATC is the official LANDKING distributor in Saudi Arabia, delivering light commercial vehicles with nationwide parts and service support."
  },
  "/locations": {
    "title": "Locations | LANDKING Showrooms Saudi Arabia",
    "description": "Find LANDKING showrooms and service centers in Saudi Arabia for vehicle sales, spare parts and aftersales assistance."
  },
  "/faq": {
    "title": "FAQ | LANDKING Saudi Arabia LCV Support",
    "description": "Frequently asked questions about LANDKING light commercial vehicles in Saudi Arabia, including warranty, spare parts and maintenance services."
  },
  "/privacy-policy": {
    "title": "Privacy Policy | LANDKING Saudi Arabia",
    "description": "Learn how LANDKING Saudi Arabia collects, uses and protects information when you visit our website or contact us."
  },
  "/terms-conditions": {
    "title": "Terms & Conditions | LANDKING Saudi Arabia",
    "description": "Terms and conditions governing the use of the LANDKING Saudi Arabia website, products and services."
  }
};

function upsertMeta(name, content) {
  if (!content) return;
  let tag = document.querySelector(`meta[name="${name}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute("name", name);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
}

function upsertProperty(property, content) {
  if (!content) return;
  let tag = document.querySelector(`meta[property="${property}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute("property", property);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
}

function upsertLink(rel, href) {
  let link = document.querySelector(`link[rel="${rel}"]`);
  if (!link) {
    link = document.createElement("link");
    link.setAttribute("rel", rel);
    document.head.appendChild(link);
  }
  link.setAttribute("href", href);
}

export default function MetaManager() {
  const { pathname } = useLocation();

  useEffect(() => {
    const data = SEO_MAP[pathname] || SEO_MAP["/"];
    const canonical = SITE.domain + (pathname === "/" ? "" : pathname);

    document.title = data.title;
    upsertMeta("description", data.description);
    upsertMeta("robots", INDEXING_ENABLED ? "index, follow" : "noindex, follow");
    upsertLink("canonical", canonical);

    upsertProperty("og:type", "website");
    upsertProperty("og:site_name", SITE.name);
    upsertProperty("og:locale", SITE.locale);
    upsertProperty("og:url", canonical);
    upsertProperty("og:title", data.title);
    upsertProperty("og:description", data.description);
    upsertProperty("og:image", SITE.ogImage);

    upsertMeta("twitter:card", SITE.twitterCard);
    upsertMeta("twitter:title", data.title);
    upsertMeta("twitter:description", data.description);
    upsertMeta("twitter:image", SITE.ogImage);
  }, [pathname]);

  return null;
}